import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
    
    constructor() { }
    @Input() totalItems: number;
    @Input() pageSize: number;
    @Input() isSizeEnable: boolean;
    @Output() pageAction: EventEmitter<object> = new EventEmitter<object>(); 

    pageSizeList = []
  
    ngOnInit() {
        this.totalItems < 10 && (this.isSizeEnable = false)
        if(this.isSizeEnable && this.pageSizeList.length == 0){
            let pageNo = this.totalItems/10;
            pageNo = pageNo % 1 !== 0 ? parseInt(pageNo.toString()) +2 : pageNo + 1
            this.pageSizeList = Array.from(Array(pageNo).keys(), x => x * 10)
            this.pageSizeList.shift()
        }
    }

    getServerData(ev) {
        console.log("page clicked", ev);
        this.pageAction.emit(ev); 
    }
    

}
